export default {
    /**
 *@function filterLabel
 *@param {String or Number} val (the filters value)
 *@param {String} data (item of a DATA_DICTIONARY_MAP) 
 */
   // 销售/采购单位 - 显示 
filterUnit: (val, val2, unit = "") => {
  if (val === unit && val2 == 1) {
    return `${val}`
  } else {
    return `${val}(${val2} ${unit})`
  }
  },
     // 小数点后两位
filterNumTwo: (val) => {
      return String(val).indexOf('.') == -1 ? val : val.toFixed(2)
  },
}